module.exports = __webpack_public_path__ + "static/media/SuccessPurple.b22381a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/SuccessPurple.svg
// module id = 924
// module chunks = 0